import SideMenuComponent from "../components/side-menu";
import NavBarComponent from "../components/navbar";
import FooterComponent from "../components/footer";
import { useWidgetManager } from "../hooks/useWidgetManager";

export default function MainScreen() {
  const { component } = useWidgetManager();

  return (
    <div>
      <div className="wrapper">
        <SideMenuComponent />
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <NavBarComponent />
              {component}
            </div>
          </div>
        </div>
      </div>
      {/* <FooterComponent /> */}
    </div>
  );
}
